import { Dialog } from '@cimplico/components';
import { useFormContext } from 'react-hook-form';
import { OnboardingXeroEntities } from './XeroEntitiesForm';
import { formatSummaryMessages } from '../utils';

type OnboardingConfirmationDialogProps = {
    isOpen: boolean;
    onClose: () => void;
    onUpdate: () => void;
};

function OnboardingConfirmationDialog({ isOpen, onClose, onUpdate }: OnboardingConfirmationDialogProps): JSX.Element {
    const { getValues } = useFormContext<OnboardingXeroEntities>();

    const values = getValues('connections');
    const summaryMessages = formatSummaryMessages(values, false);

    return (
        <Dialog
            type="info"
            title="Onboard Xero Entities"
            description="The following actions will be performed:"
            isOpen={isOpen}
            primaryAction="Confirm"
            secondaryAction="Cancel"
            onClose={onClose}
            onSecondaryActionClick={onClose}
            onPrimaryActionClick={onUpdate}
        >
            <div className="pl-4 pr-6 pb-4 flex flex-col gap-1">
                {summaryMessages.map((message, idx) => (
                    <ul key={idx} className="list-disc">
                        <li className="text-sm text-gray-500">{message}</li>
                    </ul>
                ))}
            </div>
        </Dialog>
    );
}

export default OnboardingConfirmationDialog;
